import React from 'react'
import cn from 'classnames'

import { buildSearchPath, constructSearchQueryString } from 'util/search'
import Link from 'redux-first-router-link'

import SearchRawCount from 'components/App/DesktopView/Layout/SearchRawCount'

import Item from '../Item'
import Tags from '../Tags'

class Mailbox extends React.PureComponent {
  buildMailboxPath = params => {
    const { mailbox, sortOrder } = this.props
    const isAllMailboxes = mailbox.id === null
    return buildSearchPath({ sortOrder, state: 'open' })(
      isAllMailboxes ? params : { ...params, mailbox: mailbox.id }
    )
  }

  buildMailboxFolderPath = params => {
    const { mailbox, sortOrder } = this.props
    const isAllMailboxes = mailbox.id === null
    return buildSearchPath({ sortOrder })(
      isAllMailboxes ? params : { ...params, mailbox: mailbox.id }
    )
  }

  buildMailboxQueryString = params => {
    const { mailbox } = this.props
    const isAllMailboxes = mailbox.id === null
    return constructSearchQueryString(
      isAllMailboxes
        ? params
        : {
            ...params,
            mailbox: mailbox.id,
          }
    )
  }

  render() {
    const {
      agents,
      mailbox,
      isCurrent,
      toggleTeamSection,
      toggleTagsSection,
      isTeamSectionOpen,
      isTagsSectionOpen,
      onClick,
      doOpenSearchPage,
      hideTitle,
    } = this.props
    const folders = mailbox.folders
    const firstFolder = folders && folders[0]
    const firstFolderPath =
      firstFolder && this.buildMailboxFolderPath({ folder: firstFolder.id })
    const mailboxQueryId = this.buildMailboxQueryString({ is: 'open' })
    if (!isCurrent) {
      return (
        <div className="mailbox">
          <div className="name">
            <span className="dot" style={{ backgroundColor: mailbox.color }} />
            <Link
              as="span"
              className="text"
              to={firstFolderPath}
              onClick={onClick}
            >
              {mailbox.name}
            </Link>
            <span className="count">
              <SearchRawCount queryId={mailboxQueryId} />
            </span>
          </div>
        </div>
      )
    }

    return (
      <div className="mailbox current">
        <div className="name">
          {!hideTitle && (
            <React.Fragment>
              <span
                className="dot"
                style={{ backgroundColor: mailbox.color }}
              />
              <Link
                as="span"
                className="text"
                to={firstFolderPath}
                onClick={onClick}
              >
                {mailbox.name}
              </Link>
              <span className="count">
                <SearchRawCount queryId={mailboxQueryId} />
              </span>
            </React.Fragment>
          )}
        </div>
        <div className="folders">
          {mailbox.folders.map(folder => {
            return (
              <Item
                folderId={folder.id}
                name={folder.name}
                doOpenSearchPage={doOpenSearchPage}
                className="folder folder-link"
                displayCountWhenInactive={folder.displayCountWhenInactive}
                buildMailboxFolderPath={this.buildMailboxFolderPath}
                buildMailboxQueryString={this.buildMailboxQueryString}
              />
            )
          })}
        </div>
        <div className={cn('section team', { open: isTeamSectionOpen })}>
          <div className="lead" onClick={toggleTeamSection}>
            <span className="Icon Icon-people-outline" />
            <span className="text">Team</span>
            <span className="Icon Icon-expand-more" />
          </div>
          {isTeamSectionOpen && (
            <div className="team">
              {agents &&
                agents.map(agent => {
                  return (
                    <Item
                      agentId={agent.id}
                      name={agent.shortName}
                      doOpenSearchPage={doOpenSearchPage}
                      className="agent"
                      displayCountWhenInactive
                      buildMailboxFolderPath={this.buildMailboxFolderPath}
                      buildMailboxQueryString={this.buildMailboxQueryString}
                    />
                  )
                })}
            </div>
          )}
        </div>
        <div className={cn('section tags', { open: isTagsSectionOpen })}>
          <div className="lead" onClick={toggleTagsSection}>
            <span className="Icon Icon-label-outline" />
            <span className="text">Tags</span>
            <span className="Icon Icon-expand-more" />
          </div>
          {isTagsSectionOpen && (
            <Tags
              doOpenSearchPage={doOpenSearchPage}
              buildMailboxFolderPath={this.buildMailboxFolderPath}
              buildMailboxQueryString={this.buildMailboxQueryString}
            />
          )}
        </div>
      </div>
    )
  }
}

export default Mailbox
